<template>
	<div class="module_course page_content" aria-label="Course Learn Page Content">

		<course-header :course-id="course.uuid" class="header_course_learn"></course-header>

		<div class="row page-content">



			<template v-if="isStudentLogin">
        	   <t-o-c :uuid="course.uuid"></t-o-c>
        	</template>
        	<template v-else>
                <template v-if="!isCurate">
        	       <t-o-c-instructor :uuid="course.uuid"></t-o-c-instructor>
                </template>
            </template>

			<div class="col-6 course-description"></div>

		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeader from './CourseHeader'
import CourseNav from './CourseNav'
import TOC from './TOC'
import TOCInstructor from './TOCInstructor'

export default {
  name: 'course-learn',
  props: ['uuid', 'isCurate'],
  components: {
    CourseHeader,
    CourseNav,
    TOC,
    TOCInstructor
  },
  data: () => {
    return {
      isStudentLogin: (localStorage.getItem('userrole') === 'Student')
    }
  },

  mounted () {
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadLogDashboardActivity'
    ]),

    loadCourse () {
      if (!this.isCurate) {
        this.loadLogDashboardActivity({action: 'clickLearn', page: 'courseHome', link: '', entityUuid: this.uuid})
      }
      this.loadCourseDetail(this.uuid).then(res => {
        if (this.isCurate) {
          return this.$router.push({ name: 'courseCuration', params: { uuid: this.uuid } })
        }
      })
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course
    })
  }
}
</script>

<style scoped>
.content{
  padding-top: 40px;
  margin-right: 30px;
  margin-left: 30px;
}

.course-nav{
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item{
  background:#e1e1e1;
  border: none;
}

.course-thumbnail{
  background:#f8f9fa;
  min-height: 500px;
}

.course-information{
  margin-top:20px;
}

.course-description{
  padding-top:20px;
  padding-left:20px;
  padding-right:20px;
}

.course-description-card{
  background:#f8f9fa;
  border-color: #f8f9fa;
}

.topic-list-item{
}


</style>



// WEBPACK FOOTER //
// src/app/course/components/CourseLearn.vue